import React, { Component } from 'react';
import Select from '../Select';
import styled from 'styled-components';
import find from 'lodash/find';

const StyledSelect = styled(Select)`
  .select{
    position: relative;
    
    &__control{
      border: none;
      border-radius: 0;
      // border-bottom: 1px solid #e5e3d8;
      box-shadow: none !important;
      border-bottom: ${props => props.error ? '1px solid red' : '1px solid #a2a2a2'};
      
      &:hover {border-bottom: 1px solid #303f9f;}
      &--is-focused {
        outline: none !important;
        box-shadow: none;
      }
    }
    
    &__indicator {
      color: #434875;
      padding: 2px;

      &-separator {background-color: transparent;}
    }

    &__indicator:hover {color: #434875; cursor: pointer;}
    
    &__value-container {
      padding: 0;

      :focus{outline: none;}
    }

    &__placeholder {
      margin: 0;
      padding: 0;
      color: #989689;

      &:hover{cursor: text;}
    }

    &__menu {
      text-align: left;
      z-index: 1000;
    }

    &__single-value {
      font-family: 'Quicksand',sans-serif;
      font-weight: 600;
      font-size: 1.125rem;
      color: #434875;
      margin-left: 0;
    }
  }
`;

const Label = styled.span`
  position: absolute;
  z-index: 999;
  left: 0;
  top: -10px;
  font-family: 'Quicksand',sans-serif;
  font-weight: 500;
  font-size: 12px;
  color: #989689;
  opacity: ${props => props.show ? '1' : '0'}
`;

const Wrapper = styled.div`
  position: relative;
`;

const StyledError = styled.div`
  color: #f25353;
  text-align: left;
  font-size: 0.75rem;
  padding-top: 6px;
`;

class CountrySelector extends Component {
 
  render() {
    const {
      placeholder,
      name,
      id,
      label,
      language,
      countries,
      helperText,
      value,
      error,
      onChange,
      classes,
      ...rest
    } = this.props;
    
    const options = countries
      ? countries.map((country) =>({
        value: country.twoLetterCode,
        label: country.name[language],
      }))
      : [];

    const selectedOption = find(options, option => option.value === value);
    
    return (
      <Wrapper>
        <Label show={value && value !== ''} >{placeholder}</Label>
        <StyledSelect
          id={id}
          name={name}
          placeholder={placeholder}
          error={error}
          classNamePrefix="select"
          options={options}
          value={selectedOption}   
          onChange={(selectedOption) => {
            onChange(selectedOption.value);
          }}
          // textFieldProps={{
          //   label: label,
          //   InputLabelProps: {
          //     shrink: true,
          //   },
          // }}
          {...rest}
        />
        <StyledError>
          {helperText}
        </StyledError>
      </Wrapper>
    );
  }
}

export default CountrySelector;



// WEBPACK FOOTER //
// ./src/components/CountrySelector/CountrySelector.js